"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var createCls = (0, _cssClassesHelper.getBEMClasses)('notification-item');
var NotificationItem = exports.NotificationItem = function NotificationItem(_ref) {
  var icon = _ref.icon,
    children = _ref.children,
    actions = _ref.actions,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(createCls(), className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('icon')
  }, icon), /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('content')
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('actions')
  }, actions));
};